module.exports = __webpack_public_path__ + "static/media/random 1.478f8976.jpg";